import type { PickingOrderType } from './operations/index.js';

export const PICKING_ORDER_TYPES: readonly PickingOrderType[] = [
  'SALES_ORDER',
  'WORK_ORDER',
  'TRANSFER_ORDER',
];
